import { render } from "./AiChatMessage.vue?vue&type=template&id=61c5301d&scoped=true"
import script from "./AiChatMessage.vue?vue&type=script&lang=js"
export * from "./AiChatMessage.vue?vue&type=script&lang=js"

import "./AiChatMessage.vue?vue&type=style&index=0&id=61c5301d&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c5301d"]])

export default __exports__